export default class CommentTargetTypes {
  static AUDIT = "audit";

  static DOCUMENTS = "documents";

  static TRANSACTIONS = "transactions";

  static ARCHIVE = "archive";

  static TASKS = "tasks";
}
